import React, { useState } from 'react'
import { Checkbox, TextField } from '../../ui'

export function MilestonesFacet({ milestones, onToggle, onAdd, onRemove }) {
  const [draft, setDraft] = useState('')

  if (!milestones) return null

  const items = milestones.items || []
  const doneCount = items.filter((m) => m.completed).length

  function handleAdd(e) {
    e.preventDefault()
    const title = draft.trim()
    if (!title) return
    onAdd?.(title)
    setDraft('')
  }

  return (
    <div style={styles.facet}>
      <span style={styles.count}>{doneCount}/{items.length} milestones</span>
      <div style={styles.list}>
        {items.map((m) => (
          <div key={m.id} style={styles.item}>
            <Checkbox
              checked={m.completed}
              onChange={() => onToggle?.(m.id)}
              aria-label={`Mark "${m.title}" complete`}
              style={{ margin: 0, flexShrink: 0 }}
            />
            <span style={{ ...styles.text, ...(m.completed ? styles.done : {}) }}>{m.title}</span>
            {m.targetDate && (
              <span style={styles.date}>{m.targetDate}</span>
            )}
            {onRemove && (
              <button
                type="button"
                style={styles.removeBtn}
                aria-label="Remove milestone"
                onClick={() => onRemove(m.id)}
              >×</button>
            )}
          </div>
        ))}
      </div>
      {onAdd && (
        <form onSubmit={handleAdd} style={styles.addRow}>
          <div style={{ flex: 1 }}>
            <TextField
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder="Add milestone..."
              aria-label="Add milestone"
            />
          </div>
        </form>
      )}
    </div>
  )
}

const styles = {
  facet: { display: 'flex', flexDirection: 'column', gap: '6px' },
  count: { fontSize: '10px', color: 'var(--text-secondary)' },
  list: { display: 'flex', flexDirection: 'column', gap: '4px' },
  item: { display: 'flex', alignItems: 'center', gap: '6px' },
  checkbox: { margin: 0, flexShrink: 0, cursor: 'pointer' },
  text: { fontSize: '12px', color: 'var(--text-primary)', lineHeight: 1.4 },
  done: { textDecoration: 'line-through', color: 'var(--text-secondary)' },
  date: { fontSize: '10px', color: 'var(--text-secondary)', marginLeft: 'auto' },
  removeBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '11px',
    color: 'var(--text-secondary)',
    opacity: 0.5,
    padding: '0 2px',
    flexShrink: 0,
  },
  addRow: { display: 'flex', gap: '6px' },
  addInput: {
    flex: 1,
    fontSize: '12px',
    padding: '4px 8px',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    background: 'var(--bg)',
    color: 'var(--text-primary)',
  },
}
